export default {
    payer_1: 'Medicaid',
    payer_2: 'Medicare',
    payer_3: 'Out of pocket',
    payer_4: 'Private',
};
